/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {AdditionalEquipmentOptions} from "./additionalEquipmentOptions.zod";

export const HeliportVisualAid = zod.object({
  perimeterLights: zod.boolean().nullish(),
  statusLights: zod.boolean().nullish(),
  floodLight: zod.boolean().nullish(),
  obstructionLight: zod.boolean().nullish(),
  windSock: zod.boolean().nullish(),
  tdPm: zod.boolean().nullish(),
  additionalOptions: AdditionalEquipmentOptions.and(zod.unknown()).optional(),
});

export type HeliportVisualAid = zod.input<typeof HeliportVisualAid>;
export type HeliportVisualAidOutput = zod.output<typeof HeliportVisualAid>;
